// extracted by mini-css-extract-plugin
export default {"image_mobile":"responsiveImages-module--image_mobile--NsP+R","image_desktop":"responsiveImages-module--image_desktop--ISTX5"};